import type { FC } from 'react';
import { observer } from 'mobx-react-lite';
import useRulePageMode from '../../hooks/useRulePageMode';
import useCurrentTasksFormStore from '../../hooks/useCurrentTasksFormStore';
import type { OptionValue } from '../../../../types/shared';
import { useConditionsConstants } from '../../api';
import { RuleEditAutoCompleteStyled } from '../RuleEditComponents';
import type { ConditionVariantProps } from '../../types';

export const ConstantsMetrics: FC<ConditionVariantProps> = observer(
  ({ indexCondition, indexTask, field, indexVariant }) => {
    const { isRead } = useRulePageMode();
    const isVariant = typeof indexVariant === 'number';
    const disabled = isRead || isVariant;
    const tasksFormStore = useCurrentTasksFormStore();
    const handleChangeMetric = (value: OptionValue) => {
      tasksFormStore.setConditionMetric(indexTask, indexCondition, field, value as string);
    };

    const { data: conditionsConstants } = useConditionsConstants({
      config: { select: (data) => data.map(({ name, id }) => ({ value: id, label: name })) },
    });

    const value = isVariant
      ? tasksFormStore.getVariantOnTaskCondition(indexTask, indexVariant, indexCondition)?.[field]
      : tasksFormStore.getConditionMetric(indexTask, indexCondition)?.[field];

    return (
      <RuleEditAutoCompleteStyled
        allSelectable={false}
        value={value}
        onChange={handleChangeMetric}
        id={`Autocomplete-${field}-${indexTask}-${indexCondition}`}
        options={conditionsConstants ?? []}
        InputProps={{
          ...(tasksFormStore?.propsRestriction ?? null),
          disabled: disabled,
        }}
      />
    );
  }
);

export default ConstantsMetrics;
